export function LoadingScreen({ label = 'Загрузка' }: { label?: string }) {
  return (
    <div
      style={{ minHeight: '100dvh', display: 'grid', placeItems: 'center' }}
      role="status"
      aria-live="polite"
    >
      <div className="state-block">
        <span className="spinner" aria-hidden="true" />
        <p>{label}</p>
      </div>
    </div>
  );
}
